"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ctaRowDataType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var ctaRowDataType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  CTAs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string,
    ctaType: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    theme: _propTypes["default"].string,
    icon: _propTypes["default"].string
  }))
});

// eslint-disable-next-line import/prefer-default-export
exports.ctaRowDataType = ctaRowDataType;